import type { FilterOption } from "@/components/shared/data-table";
import { useMe } from "@/hooks/use-auth";
import { useWorkspaces } from "@/hooks/use-workspaces";

// Only canSwitchWorkspace roles (Developer/Franchisor) get a workspace
// filter at all — everyone else is always pinned to their own workspace
// server-side, so showing them a filter that does nothing would be
// confusing. Returns [] (no extra filter) for everyone else.
export function useWorkspaceFilterOption(): FilterOption[] {
  const { data: me } = useMe();
  const { data: workspacesData } = useWorkspaces({ per_page: 100 });

  if (!me?.canSwitchWorkspace) return [];

  const workspaces = (workspacesData?.items ?? []).filter((w) => w.isActive);

  return [
    {
      key: "workspace_id",
      label: "Workspace",
      options: workspaces.map((w) => ({ value: w.id, label: w.name })),
      searchable: true,
    },
  ];
}
